export const booleanDictionary = [
  {
    id: true,
    name: "Да",
  },
  {
    id: false,
    name: "Нет",
  },
];
